import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BaseContentControlWrapper } from '../../../components/ContentControlWrapper.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
const QuizControlBar = ({
  buttonDisabled,
  onClick,
  hasAnsweredCurrentQuestion
}) => /*#__PURE__*/_jsx(BaseContentControlWrapper, {
  children: /*#__PURE__*/_jsx(Button, {
    "data-test-id": "quiz-control-bar-button",
    disabled: buttonDisabled,
    onClick: onClick,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.quiz.${hasAnsweredCurrentQuestion ? 'next' : 'checkAnswer'}`
    })
  })
});
export default QuizControlBar;